module.exports = __webpack_public_path__ + "static/media/deposit_example.c32c4de7.png";